<template>
  <div :class="`video-wrapper muted-${isMuted}`">
    <!--      <div class="video-controls"> -->
    <v-toolbar dense absolute class="video-toolbar right">
      <v-btn icon tile @click="toggleMute" v-if="!isMuted && playing" color="white">
        <v-icon size="32">mdi-volume-high</v-icon>
      </v-btn>
      <v-btn icon tile @click="toggleFullScreen" color="white">
        <v-icon size="32">mdi-fullscreen</v-icon>
      </v-btn>
    </v-toolbar>
    <v-overlay absolute v-if="isMuted && playing" @click.native="toggleMute" class="cursor-pointer">
      <v-icon size="72">mdi-volume-off</v-icon>
    </v-overlay>
    <v-overlay absolute v-if="!playing" @click.native="manualPlay" class="cursor-pointer">
      <v-icon size="72">mdi-play</v-icon>
    </v-overlay>
    <!--      </div> -->
    <span v-if="videoMode === 'youTube'" id="player" class="video"></span>
    <div v-if="videoMode === 'vimeo' || videoMode === 'dacast'" id="player" class="video"></div>
    <slot></slot>
  </div>
</template>

<script>
import YouTubeIframeLoader from "youtube-iframe";
import moment from "moment";

const videoType = {
  YT: "youTube",
  VIMEO: "vimeo",
  DACAST: "dacast",
};
export default {
  name: "VideoPlayer",
  props: {
    volume: {
      type: Number,
      default: 100,
    },
    isMuted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      videoLinkNormalised: null,
      videoMode: null,
      player: null,
      playing: true,
      vimeoSDK: false,
      dacastPlayer: null,
      initialized: false,
    };
  },
  watch: {
    volume: {
      handler() {
        this.handleVolume();
      },
      immediate: false,
    },
    isMuted: {
      handler(value) {
        this.setMuted(value);
      },
      immediate: false,
    }
  },
  methods: {
    manualPlay() {
      const player = this.getPlayer();
      this.playing = true;
      switch (this.videoMode) {
        case "youTube":
          player.playVideo();
          break;
        case "vimeo":
          player.play();
          break;
        case "dacast":
          player.play();
          break;
      }
    },
    toggleMute() {
      this.$store.commit("VIDEO_MUTED", !this.isMuted);
    },
    setMuted(muted){
      let player = this.getPlayer();
      if (!player) return;
      if (this.videoMode === "vimeo") {
        player.setMuted(muted);
      } else if (this.videoMode === "dacast") {
        player.mute(this.muted);
      } else {
        if (muted) {
          player.mute();
        } else {
          player.unMute();
        }
      }
    },
    toggleFullScreen() {
      this.$store.dispatch("TOGGLE_FULLSCREEN");
    },
    getVideoType() {
      const activity = this.$store.state.selectedActivity;
      if (activity && activity.link) {
        if (activity.link.indexOf("youtube") > -1 || activity.link.indexOf("youtu.be") > -1) {
          return videoType.YT;
        }
        if (activity.link.indexOf("vimeo") > -1) {
          return videoType.VIMEO;
        }
        if (activity.link.indexOf("dacast") > -1) {
          return videoType.DACAST;
        }
      }
      return null;
    },
    getVideoLinkNormalised() {
      const activity = this.$store.state.selectedActivity;
      if (activity && activity.link) {
        if (activity.link.indexOf("watch?v=") > -1) {
          return activity.link.split("watch?v=")[1];
        }
        if (activity.link.indexOf("https://youtu.be/") > -1) {
          return activity.link.split("be/")[1];
        }
        if (activity.link.indexOf("vimeo.com") > -1) {
          return activity.link;
        }
        if (activity.link.indexOf("dacast") > -1) {
          if (activity.link.indexOf("player.dacast.com/js/player.js") > -1) return activity.link;

          if (activity.link.indexOf("iframe.dacast.com") > -1) {
            let type;
            if (activity.link.indexOf("vod") > -1) type = "vod";
            if (activity.link.indexOf("live") > -1) type = "live";

            if (!type) return activity.link;

            let contentId = activity.link.split(`${type}/`)[1];
            let contentPrefix = contentId.split("/")[0];

            let contentSuffix = contentId.split("/")[1];

            return `https://player.dacast.com/js/player.js?contentId=${contentPrefix}-${type}-${contentSuffix}`;
          }
        }
        return activity.link;
      }
      return null;
    },
    iOS() {
      return (
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      );
    },
    getTimeDiff() {
      if (!this.$store.state.serverTime) return 0;
      const activity = this.$store.state.selectedActivity;
      const activityTime = moment(activity.date);
      if (activity.preStartVideo && activity.preStartVideo > 0) {
        activityTime.subtract(activity.preStartVideo, "s");
      }
      let diff = moment.duration(this.$store.state.serverTime.diff(activityTime)).asSeconds();
      if (diff < 0) {
        diff = 0;
      }
      return diff;
    },
    runYoutubeApi() {
      const videoId = this.getVideoLinkNormalised();
      const diff = this.getTimeDiff();
      const isIOS = this.iOS();
      YouTubeIframeLoader.load((YT) => {
        let unMuted = false;
        new YT.Player("player", {
          videoId: videoId,
          playerVars: {
            autoplay: 1,
            playsinline: 1,
            controls: 0,
            start: diff,
            showinfo: 0,
            autohide: 0,
            disablekb: 0,
            modestbranding: 1,
            rel: 0,
          },
          events: {
            onReady: (event) => {
              if (this.isMuted) {
                event.target.mute();
              }
              event.target.playVideo();
              this.player = event.target;
            },
            onStateChange: (event) => {
              this.playing = event.data == YT.PlayerState.PLAYING;
              if (event.data == YT.PlayerState.PLAYING && !unMuted && !this.isMuted) {
                setTimeout(() => {
                  if (!isIOS) {
                    event.target.unMute();
                  }
                }, 2000);
                unMuted = true;
              }
              if (event.data == YT.PlayerState.ENDED) {
                this.$emit("ended");
              }
            },
          },
        });
        this.initialized = true;
      });
    },
    handleVolume() {
      if (this.isMuted || !this.initialized) return;
      const player = this.getPlayer();
      if (!player) return;
      let adjustedVolume;
      switch (this.videoMode) {
        case "youTube":
          adjustedVolume = this.volume;
          player.setVolume(adjustedVolume);
          break;
        case "vimeo":
          adjustedVolume = this.volume / 100;
          player.setVolume(adjustedVolume);
          break;
        case "dacast":
          adjustedVolume = this.volume / 100;
          player.mute(this.isMuted);
          player.volume(adjustedVolume);
          break;
      }
    },
    getPlayer() {
      switch ((this.videoMode = this.getVideoType())) {
        case "youTube":
          return this.player;
        case "vimeo":
          if (document.getElementById("player")) {
            return new window.Vimeo.Player(document.getElementById("player"));
          } else {
            return null;
          }
        case "dacast": {
          return this.dacastPlayer;
        }
      }
    },
    runVimeo() {
      const diff = this.getTimeDiff();
      this.injectVimeoSDK().then(() => {
        let videoOptions = {
          url: this.getVideoLinkNormalised(),
          autoplay: true,
          autopause: false,
          title: false,
          byline: false,
          portrait: false,
          sidedock: false,
          muted: this.isMuted,
        };
        const player = new window.Vimeo.Player("player", videoOptions);
        player.setCurrentTime(diff);
        player.getPaused().then((paused) => {
          this.playing = !paused;
        });
        player.on("pause", () => {
          this.playing = false;
        });
        player.on("play", () => {
          this.playing = true;
        });
        player.on("ended", () => this.$emit("ended"));
        this.initialized = true;
      });
    },
    runDacast() {
      this.$loadScript(this.getVideoLinkNormalised()).then(() => {
        let activityLinkUrl = new URL(this.getVideoLinkNormalised());
        let urlParams = new URLSearchParams(activityLinkUrl.search);
        let contentId = urlParams.get("contentId");

        // eslint-disable-next-line no-undef
        this.dacastPlayer = dacast(contentId, "player");

        this.dacastPlayer.on("ready", () => {
          if (this.isMuted) {
            this.dacastPlayer.mute(true);
          }

          const diff = this.getTimeDiff();
          this.dacastPlayer.currentTime(diff);
          this.handleVolume();
          this.dacastPlayer.play();
        });
        this.dacastPlayer.on("complete", () => this.$emit("ended"));
        this.initialized = true;
      });
    },
    injectVimeoSDK() {
      return new Promise((resolve) => {
        if (this.vimeoSDK) {
          setTimeout(function () {
            resolve();
          });
        }

        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://player.vimeo.com/api/player.js";
        script.onload = () => {
          resolve();
        };
        document.body.appendChild(script);
      });
    },
    runPlayer() {
      switch ((this.videoMode = this.getVideoType())) {
        case "youTube":
          this.runYoutubeApi();
          setTimeout(() => this.handleVolume(), 100);
          break;
        case "vimeo":
          this.runVimeo();
          setTimeout(() => this.handleVolume(), 100);
          break;
        case "dacast":
          this.runDacast();
          break;
      }
    },
  },
  async mounted() {
    this.initialized = false;
    this.runPlayer();
  },
};
</script>

<style scoped>
.teamcaptain-video {
  position: absolute;
  bottom: 0;
  right: 0;
  overflow: hidden;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
